const text = (value) => typeof value === 'string' ? value.trim() : '';
const generatedAccount = /^USER_[0-9a-f]{8,}$/i;
const generatedSpace = /^(USER_[0-9a-f]{8,})(?:\s*的(?:个人)?空间)?$/i;

export function userDisplayLabel(user, fallback = '未设置昵称') {
  return [user && user.display_name, user && user.username]
    .map(text).find((value) => value && !generatedAccount.test(value)) || fallback;
}

// A space belongs to its owner, not necessarily to the signed-in member.
// Use the session nickname only when the owner identity is known to match.
export function spaceDisplayLabel(space, currentUser) {
  const name = text(space && space.name);
  const generated = name.match(generatedSpace);
  const currentID = text(currentUser && (currentUser.id || currentUser.public_id));
  const ownerID = text(space && space.owner_id);
  const ownSpace = ownerID ? ownerID === currentID : generated
    && generated[1].toLowerCase() === text(currentUser && currentUser.username).toLowerCase();
  const owner = ownSpace ? currentUser : {
    display_name: space && space.owner_display_name,
    username: space && space.owner_username,
  };
  const nickname = userDisplayLabel(owner, '');
  const spaceName = generated || !name ? '个人空间' : name;
  return nickname && nickname !== spaceName ? `${nickname}（${spaceName}）` : spaceName;
}

export function memberContactLabel(user) {
  return text(user && user.email) || text(user && user.phone) || '';
}
